<template>
  <div id="osList">

    <filtros-movimentacao>

    </filtros-movimentacao>

    <div class="table-responsive">
      <table class="table table-striped tabelaInventario">
        <thead>
          <tr>
            <th scope="col">{{ $t('AÇÃO')}}</th>
            <th scope="col">{{ $t('PLACA')}}</th>
            <th scope="col">{{ $t('TIPO')}}</th>
            <th scope="col">{{ $t('CONJUNTO')}}</th>
            <th scope="col" class="text-left">{{ $t('ÚLTIMA MOVIMENTACAO')}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(placa, index) in placas" :key="index" >
            <th scope="row">
              <b-button class="btn" v-b-modal.modalMilimetragem @click="submitPlacaModal(placa)">
                <i class="fa fa-pen"></i>
              </b-button>
            </th>
            <td>{{ placa.nr_placa }}</td>
            <td>{{ placa.ds_tipoveiculo }}</td>
            <td>{{ placa.ds_conjunto }}</td>
            <td class="text-left">{{ placa.ultima_movimentacao ? placa.ultima_movimentacao : $t('Nunca feito') + '!'  | formatDate("DD/MM/YYYY")}}</td>
          </tr>
        </tbody>  
      </table>
    </div>
    <modal-troca-pneu ref="childAfericao" :nr_placa="placa" @refreshCaminhao="submitPlacaModal"></modal-troca-pneu>
  </div>
</template>

<script>
import FiltrosMovimentacao from '@/components/FiltrosMovimentacao'
import ModalTrocaPneu from '@/components/Borracharia/ModalTrocaPneu'

export default {
  components: {
    FiltrosMovimentacao,
    ModalTrocaPneu
  },

  data() {
    return {
      placa: '',
      showTrocaPneu: false
    }
  },

  computed: {
    placas() {
      const placas = this.$store.getters['borracharia/getPlacas']

      if (!placas) {
        this.$store.dispatch('borracharia/fetchFromPlacas', {})
      }

      return placas
    },
    paginacao() {
      return this.$store.getters['os/pagination']
    },
  },

  mounted() {
    this.$store.dispatch('borracharia/fetchFromPlacas', {})
  },

  methods: {
    validaDataMM(placa) {
      if(!placa.mm) {
        return placa
      }
      const data = new Date(placa.mm)

      const dataAtual = new Date();

      const diferencaEmMilissegundos = dataAtual - data;

      // Converta essa diferença de milissegundos para dias
      const diferencaEmDias = diferencaEmMilissegundos / (1000 * 60 * 60 * 24);
      
      // Verifique se o número de dias é maior que 30
      if (diferencaEmDias > 30) {
        return 'background: linear-gradient(45deg, #992d2d, #fd6565); color: #fff;'
        // console.log('A data é maior que 30 dias em relação à data atual.');
      } else if (diferencaEmDias > 20) {
        return 'background: linear-gradient(45deg, #ebc420, #fde765);'
        // console.log('A data não é maior que 30 dias em relação à data atual.');
      }

      return ''

    },
    submitPlacaModal(placa) {
      console.log(placa)
      this.$store.dispatch('borracharia/getPlacaMovimentacoes', { data: placa }).then(() => {
        this.$refs.childAfericao.gerarCaminhao()
        this.$refs.childAfericao.adicionarAcao()
        this.$refs.childAfericao.adicionarClassePneu()
        this.placa = placa
      })

      // this.propsPlaca = placa
    }
  }
}
</script>

<style lang="scss">
.icon--custom {
  top: 50px;
}

// .backgroundWarning {

// }

.backgroundError {
  background: linear-gradient(45deg, #992d2d, #fd6565);
  color: #fff;
}

// .content {
//   padding: 0 0;
// }
// .container-fluid{
//   padding-right: 0px;
//   padding-left: 0px;
// }</style>